import colors from "../../../Constants/colors";
import theme from "../../../Constants/theme";

export const pricingContainer = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  backgroundColor: colors.extremeBlue,
  height: "auto",
  px: "40px",
};

export const subscriptionCardLayout = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  borderRadius: theme.borderRadius.lg,
  backgroundColor: theme.backgroundColors.dark.blackVariants.secondary,
  border: `1px solid ${theme.border.divider}`,
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
};

export const textfieldLayout = {
  backgroundColor: "var(--secondaryBlue)",
  borderRadius: "5px",
  boxShadow: "0px 4px 12px var(--secondaryBlue)",
  "& .MuiInputBase-input": {
    color: colors.extremeWhite, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: "var(--extremeWhite)",
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeWhite,
  },
  border: `1px solid ${colors.primaryBlue}`,
};
